export const regionIds = {
    usa: 'usa',
    mexico: 'mexico',
    canada: 'canada',
    europe: 'europe',
    middleEast: 'middleEast',
    caribbean: 'caribbean',
    australia: 'australia',
    asia: 'asia',
    africa: 'africa',
    oceania: 'oceania',
    centralAmerica: 'centralAmerica',
    southAmerica: 'southAmerica'
};



// WEBPACK FOOTER //
// ./src/lib/localization/regionIds.js